import { ReactElement } from 'react';

import { Table } from 'modules/common/components/Table';
import { IDeFiItem } from 'modules/defi/types';
import { useTranslation } from 'modules/i18n';

import { DeFiTableRow } from '../DeFiTableRow';
import { translation } from './translation';

interface ITableProps {
  defies: IDeFiItem[];
}

export function DeFiTable({ defies }: ITableProps): ReactElement {
  const { t, keys } = useTranslation(translation);

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>{t(keys.assets)}</Table.HeadCell>

          <Table.HeadCell>{t(keys.protocol)}</Table.HeadCell>

          <Table.HeadCell>{t(keys.network)}</Table.HeadCell>

          <Table.HeadCell align="right">{t(keys.actions)}</Table.HeadCell>
        </Table.Row>
      </Table.Head>

      <Table.Body>
        {defies.map(defiData => (
          <DeFiTableRow
            key={`${defiData.protocol}${defiData.network}${defiData.link}`}
            data={defiData}
          />
        ))}
      </Table.Body>
    </Table>
  );
}
